import { render, staticRenderFns } from "./WGList.vue?vue&type=template&id=2be47d0d&scoped=true&"
import script from "./WGList.vue?vue&type=script&lang=js&"
export * from "./WGList.vue?vue&type=script&lang=js&"
import style0 from "./WGList.vue?vue&type=style&index=0&id=2be47d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be47d0d",
  null
  
)

export default component.exports